// ** React Imports
import { createContext, useRef } from 'react'
import PropTypes from 'prop-types';
import Tangled from '../core/tangled-sdk';

// ** Create Context
export const TangledContext = createContext(undefined)

export const TangledContextProvider = ({ children }) => {
    // ** State
    const tangled = useRef(new Tangled(process.env.REACT_APP_TANGLED_APP_GUID));
    
    return <TangledContext.Provider value={tangled}>{children}</TangledContext.Provider>
}

TangledContextProvider.propTypes = {
    children: PropTypes.element
}

export const UserConsumer = TangledContext.Consumer
